import dayjs, { Dayjs } from 'dayjs'

export type ActionLoteForm = 'REGISTER' | 'UPDATE'

export const actionLoteForm: Record<ActionLoteForm, ActionLoteForm> = {
  REGISTER: 'REGISTER',
  UPDATE: 'UPDATE',
}

/**
 * @description Modelo de Lote
 */
export interface LoteBaseProps {
  _id: string
  codigoLote: string
  descripcion: string
  atributo1: string
  atributo2: string
  atributo3: string
  fechaAdmision: string
  fechaFabricacion: string
  state?: string
  fechaVencimiento: string
  usucre?: string
  createdAt?: Date
  usumod?: string
  updatedAt?: string
}

export interface LoteProps extends LoteBaseProps {}

export interface LoteInputProps {
  codigoLote: string
  descripcion: string
  fechaAdmision: Dayjs
  fechaFabricacion: Dayjs | null
  fechaVencimiento: Dayjs | null
  atributo1: string
  atributo2: string
  atributo3: string
}

export interface LoteOutputProps {
  descripcion: string
  atributo1: string
  atributo2: string
  fechaAdmision: string
  fechaFabricacion: string
  fechaVencimiento: string
}

export const LOTE_INITIAL_VALUES: LoteInputProps = {
  codigoLote: '',
  descripcion: '',
  fechaAdmision: dayjs(new Date()),
  fechaFabricacion: null,
  fechaVencimiento: null,
  atributo1: '',
  atributo2: '',
  atributo3: '',
}
